module.exports = __webpack_public_path__ + "img/Data analyzing _Outline.27a4496d.png";